import React, { useState } from 'react'
import './style.css'
import DownloadButtons from '../downloadButtons/DownloadButtons'
import instance from '../../services/instance'
import { endpoints } from '../../constants/endpoints'
import { toast } from 'react-toastify'
import { useFormik } from 'formik'
import { contactFormSchema } from '../../schemas/contactFormSchema'

const ContactForm = () => {
    const [loading, setLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            full_name: '',
            phone_code: '+1',
            phone_number: '',
            email: '',
            message: ''
        },
        validationSchema: contactFormSchema,
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            try {
                const response = await instance.post(endpoints.submitContactForm(), values);
                if (response?.data?.status === true) {
                    toast.success('Your message has been sent successfully!');
                    resetForm();
                } else {
                    toast.error(response?.data?.message || 'Failed to send message. Please try again.');
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Failed to send message. Please try again.');
            } finally {
                setLoading(false);
            }
        }
    });

    return (
        <>
            <div className="contact-form-box">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <h1 className="home-main-heading">Contact Us</h1>
                            <h3 className='sub-heading'>I-Sit Corporation</h3>
                            <p className='common-text text-align-contact'><i className="fa-solid fa-envelope mail-icon"></i> Info@isit.services</p>

                            <DownloadButtons />
                        </div>

                        <div className="col-md-6">
                            <form onSubmit={formik.handleSubmit} className="contact-form">
                                <h1 className="home-main-heading text-center mb-4">Get in touch</h1>

                                <div className="mb-3 custom-input-box">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Full Name"
                                        name="full_name"
                                        value={formik.values.full_name}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.full_name && formik.errors.full_name && (
                                        <small className="text-danger">{formik.errors.full_name}</small>
                                    )}
                                </div>

                                <div className="form-box-inputs custom-input-box">
                                    <input
                                        type="text"
                                        className="phone-code"
                                        name="phone_code"
                                        value={formik.values.phone_code}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Phone Number"
                                        className="phone-number"
                                        name="phone_number"
                                        value={formik.values.phone_number}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.phone_code && formik.errors.phone_code && (
                                    <small className="text-danger d-block">{formik.errors.phone_code}</small>
                                )}
                                {formik.touched.phone_number && formik.errors.phone_number && (
                                    <small className="text-danger d-block">{formik.errors.phone_number}</small>
                                )}

                                <div className="mb-3 custom-input-box mt-3">
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Email Address"
                                        name="email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.email && formik.errors.email && (
                                        <small className="text-danger">{formik.errors.email}</small>
                                    )}
                                </div>

                                <div className="mb-3 custom-input-box">
                                    <textarea
                                        className="form-control"
                                        placeholder="Your Message"
                                        name="message"
                                        rows="4"
                                        value={formik.values.message}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.message && formik.errors.message && (
                                        <small className="text-danger">{formik.errors.message}</small>
                                    )}
                                </div>

                                <div className="submit-btn-form">
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={loading}
                                    >
                                        {loading ? 'Sending...' : 'Submit'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactForm
